import contextBasedEnvironment from "./contextBasedEnvironment";

export default contextValues => contextValues[contextBasedEnvironment()];